import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=21b92638&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"
import style0 from "./Manage.vue?vue&type=style&index=0&id=21b92638&prod&scoped=true&lang=scss"
import style1 from "./Manage.vue?vue&type=style&index=1&id=21b92638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b92638",
  null
  
)

export default component.exports